<template>
  <div>
    <data-list :payload="listPayloadObj" class="mt-3" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: { active: true, checklist_template_ids: [] },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.DEVIATION_WORKFLOW_STATES_INDEX) ? this.$store.state.DEVIATION_WORKFLOW_STATES_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'workflowstates',
      checklistTemplates: [],
      PACKING_ID: +process.env.VUE_APP_ORDER_PACKING_ID,
      PLANNING_ID: +process.env.VUE_APP_ORDER_PLANNING_ID,
      PRESSING_ID: +process.env.VUE_APP_ORDER_PRESSING_ID
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isModal: true
        // width: '30%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'active',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }, {
        text: this.$t('message.customer.description'),
        value: 'description',
        width: '20%'
      }]
    },
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.settings.update_workflowStates') : this.$t('message.settings.add_workflowStates'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.crm.name'),
          class: 'xs6'
        }, {
          model: 'active',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isActive')
        }, {
          model: 'description',
          rules: [],
          type: this.FORM_TYPE.TEXT,
          class: 'xs6 lg12 pt-2',
          label: this.$t('message.customer.description')
        }, {
          model: 'checklist_template_ids',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          multiple: true,
          label: this.$t('message.layout.checklist'),
          items: this.checklistTemplates,
          select_text: 'name',
          select_value: 'id',
          class: 'xs6 lg12 pt-2'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    'listPayloadObj.selection' (value) {
      var defaultValueIndex = value.findIndex(x => x.id === this.PLANNING_ID || x.id === this.PRESSING_ID || x.id === this.PACKING_ID)
      if (defaultValueIndex >= 0) {
        this.listPayloadObj.selection.splice(defaultValueIndex, 1)
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.unableToDelete') })
      }
    },
    pagination: {
      handler (val) {
        const model = {
          type: 'DEVIATION_WORKFLOW_STATES_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    this.getAllChecklistTemplates()
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      const queryFields = this.$formatter.cloneVariable(this.headers)
      const { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const query = {
        order_by: {
          field: sortBy.join(''),
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE}/query`, query)
        .then((response) => {
          const { values, count } = response.data
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
        })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE}/${id}`)
        .then((result) => {
          if (result.data) {
            const model = result.data
            if (model.checklist_template_ids) {
              model.checklist_template_ids = JSON.parse(model.checklist_template_ids)
            }
            this.modelObj = model
          }
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.modelObj.active = true
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        if (!this.modelObj.isdefault) this.modelObj.isdefault = false
        const model = this.modelObj
        model.position = model.position || null
        if (model.checklist_template_ids) {
          model.checklist_template_ids = JSON.stringify(model.checklist_template_ids)
        }
        const url = this.MODULE
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    getAllChecklistTemplates () {
      const query = {
        filter: 'status eq \'completed\''
      }
      this.$_executeApi('post', 'checklisttemplates/query', query)
        .then((response) => {
          this.checklistTemplates = response.data
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
